module.exports = __webpack_public_path__ + "static/img/11areaA_15.e246e53.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/11areaA_15.png
// module id = 883
// module chunks = 1